export default __webpack_public_path__ + "02da5777473a04bdc0199d39cab09e2b.png";